/** funciones para el modulo de solicitudes masivas en proceso */
import axiosMailUpdate from '../services/axiosApi'
var requestsAssigned = {
    async getAssigneds() {
        const response = await axiosMailUpdate.get('api/v1/request/assigned?sort_by=created_at')
        this.response = response.data.data
        // con filter solo se muestra las solicitudes con el estatus 8 (asignadas)
        //this.response = response.data.data.filter(el => el.idstatus === 8 )
        return this.response
    },
    async getProgress(idRequest) {
        const response = await axiosMailUpdate.get('api/v1/requests/'+idRequest+'/detailedassignment')
        this.response = response.data.data
        return this.response
    },
    async getSpecificUser(idUserGet) {
        const response = await axiosMailUpdate.get('api/v1/users/' + idUserGet)
        this.response = response.data.data
        return this.response
    },
}
export default requestsAssigned